import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Animacao } from '../../core/tools/animacao';
import { PdfService } from '../../core/tools/pdf.service';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { AutomacaoEventoService } from '../../core/services/automacao-eventos/automacao-evento.service';
import { CallCenterService } from '../../core/services/call-center/call-center.service';
import { CallCenterDiscadorService } from '../../core/services/call-center-discador/call-center-discador.service';
import { CanaisComunicacaoTelefoniaService } from '../../core/services/canais-comunicacao/telefonia/canais-comunicacao-telefonia.service';
import { CentralAtendimentoService } from '../../core/services/central-atendimento/central-atendimento.service';
import { ClienteService } from '../../core/services/clientes/cliente.service';
import { ConfiguracaoService } from '../../core/services/configuracoes/configuracao.service';
import { ConversaoService } from '../../core/tools/conversao.service';
import { ExcelService } from '../../core/tools/excel.service';
import { FormatacaoService } from '../../core/tools/formatacao.service';
import { NotaFiscalService } from '../../core/services/notas-fiscais/nota-fiscal.service';
import { PedidoItensService } from '../../core/services/pedidos/pedido-itens.service';
import { PedidoService } from '../../core/services/pedidos/pedido.service';
import { ProdutoService } from '../../core/services/produtos/produto.service';
import { TempoProgressivoService } from '../../core/tools/tempo-progressivo.service';
import { TempoRegressivoService } from '../../core/tools/tempo-regressivo.service';
import { VendedorService } from '../../core/services/vendedores/vendedor.service';
import { VisitaService } from '../../core/services/visitas/visita.service';
import { WhatsAppOfficialService } from '../../core/services/whatsapp-oficial/whatsapp-oficial.service';
import { KanbanService } from '../../core/services/kanban/kanban.service';

/* Models */

import { AutomacaoEvento } from '../../core/models/automacao-eventos/automacao-evento';
import { AutomacaoEnvio } from '../../core/models/automacao-eventos/automacao-envio';
import { CallCenterAgendamento } from '../../core/models/call-center/call-center-agendamento';
import { CallCenterConfiguracao } from '../../core/models/call-center/call-center-configuracao';
import { CallCenterVendaMensal } from '../../core/models/call-center/call-center-venda-mensal';
import { CallCenterVendaMarca } from '../../core/models/call-center/call-center-venda-marca';
import { CallCenterTopProduto } from '../../core/models/call-center/call-center-top-produto';
import { CallCenterComparativoTrimestralProduto } from '../../core/models/call-center/call-center-comparativo-trimestral-produto';
import { CallCenterLigacaoAnalitica } from '../../core/models/call-center/call-center-ligacao-analitica';
import { CallCenterQualificacaoQuestao } from '../../core/models/call-center/call-center-qualificacao-questao';
import { CallCenterQualificacaoQuestaoResposta } from '../../core/models/call-center/call-center-qualificacao-questao-resposta';
import { CallCenterResultado } from '../../core/models/call-center/call-center-resultado';
import { CallCenterStatus } from '../../core/models/call-center/call-center-status';
import { CentralAtendimentoEvento } from '../../core/models/central-atendimento/central-atendimento-evento';
import { Cliente } from '../../core/models/clientes/cliente';
import { ClienteLocalEntrega } from '../../core/models/clientes/cliente-local-entrega';
import { ClienteTabela } from '../../core/models/clientes/cliente-tabela';
import { Configuracao } from '../../core/models/configuracoes/configuracao';
import { KanbanNegocio } from '../../core/models/kanban/kanban';
import { IaChatHistorico, IaConfiguracaoCliente, IaResposta } from '../../core/models/ia/ia';
import { IaService } from '../../core/services/ia/ia.service';
import { NotaFiscalSintetica } from '../../core/models/notas-fiscais/nota-fiscal-sintetica';
import { Pedido } from '../../core/models/pedidos/pedido';
import { PedidoItensSintetico } from '../../core/models/pedidos/pedido-itens-sintetico';
import { PedidoSintetico } from '../../core/models/pedidos/pedido-sintetico';
import { ProdutoCesta } from '../../core/models/produtos/produto-cesta';
import { Visita } from '../../core/models/visitas/visita';
import { WhatsAppOfficialAtendimento } from '../../core/models/whatsapp-oficial/whatsapp-oficial-atendimento';
import { ResumoFinanceiro, TituloFinanceiro } from '../../core/models/financeiro/resumo-financeiro';

interface IaChatMensagem {
  origem: "USUARIO" | "IA";
  texto: string;
  tipo?: string;
  mensagem?: string;
  sucesso?: boolean;
  data?: Date;
  produtos_sugeridos?: any[];
}

@Component({
    selector: 'app-call-center-ligacao',
    templateUrl: './call-center-ligacao.component.html',
    styleUrls: ['./call-center-ligacao.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class CallCenterLigacaoComponent implements OnInit {
  /* Emitter */

  eventosEmitter: Subscription = null;
  redirecionarPorTempoEmitter: Subscription = null;

  /* Carregamento */

  carregando: boolean = false;

  carregadoCesta: boolean = false;
  carregadoPedidos: boolean = false;
  carregadoQualificacao: boolean = false;
  carregadoVisitas: boolean = false;

  /* Análise de Vendas */

    /* Alertas */

    intervaloMedioDiasCompra: number = 0;
    compraForaDoPadrao: boolean = false;

    valorVendasMesAtual: number = 0;
    valorVendasMesAnterior: number = 0;
    variacaoMesPercentual: number = null;
    nomeMesAtual: string = "";
    nomeMesAnterior: string = "";

    produtoResgateNome: string = null;
    produtoResgateFrequencia: number = 0;
    produtoResgateTotalPedidosAnteriores: number = 0;
    produtoResgateTicketMedio: number = 0;

    /* Vendas por Mês (6 Meses) */

    vendasMensais6Meses: CallCenterVendaMensal[] = [];
    maiorValorVendaMensal: number = 0;

    /* Vendas por Marca (Mês Atual) */

    vendasPorMarcaMesAtual: CallCenterVendaMarca[] = [];

    /* Top 10 Produtos (Mês Atual x Mês Anterior) */

    topProdutosMes: CallCenterTopProduto[] = [];

    /* Comparativo Trimestral por Produto (3 Meses x 3 Meses Anteriores) */

    comparativoTrimestralDtInicioRecente: Date = null;
    comparativoTrimestralDtFimRecente: Date = null;

    comparativoTrimestralDtInicioAnterior: Date = null;
    comparativoTrimestralDtFimAnterior: Date = null;

    comparativoTrimestralProdutos: CallCenterComparativoTrimestralProduto[] = [];

  /* Dados */

    /* Call Center (Agendamento) */

    callCenterAgendamentos: CallCenterAgendamento[] = [];

    callCenterAgendamentoSelecionado: CallCenterAgendamento = null;

    alterarLigacaoData: { year: number, month: number, day: number } = null;
    alterarLigacaoDataInvalida: boolean = false;
    alterarLigacaoHora: { hour: number, minute: number } = null;

    /* Call Center (Configurações) */

    callCenterConfiguracao: CallCenterConfiguracao = null;

    /* Call Center (Ligação) */

    ligacao: CallCenterLigacaoAnalitica = null;
    ligacaoFutura: CallCenterLigacaoAnalitica = null;

    /* Call Center (Resultados) */

    resultados: CallCenterResultado[] = []

    resultadoSelecionado: CallCenterResultado = null;

    /* Call Center (Status) */

    status: CallCenterStatus[] = [];

    statusSelecionado: CallCenterStatus = null;

    /* Cliente */

    cliente: Cliente = null;

    insideSales: boolean = false;
    contatoCliente: string = "";
    telefone_2: string = "";
    telefone_3: string = "";
    dddWhatsApp: string = "";
    telefoneWhatsApp: string = "";
    email_02: string = "";
    observacaoCliente: string = "";

    /* Cliente (Tabela) */

    tabelasClientes: ClienteTabela[] = [];

    /* Configurações */

    configuracao: Configuracao = null;

    /* Grupos Estoque */

    gruposEstoque: string[] = [];

    /* Qualificação (Questões) */

    callCenterQualificacaoQuestoes: CallCenterQualificacaoQuestao[] = [];
    callCenterQualificacaoQuestoesRespostas: CallCenterQualificacaoQuestaoResposta[] = [];

    /* Produtos (Cesta) */

    produtosCesta: ProdutoCesta[] = [];

    /* Visita */

    visita: Visita = null;
    visitas: Visita[] = [];

    visitaSelecionada: Visita = null;

    nroVisita: number = 0;

    observacaoVisita: string = "";

    /* Externo */

      /* Cliente Consulta (Externo) */

      clienteConsultaSelecionadoExterno: number = 0;
      whatsappAtendimentoAnaliseId: number = null;
      pedidoPdfEnviando: PedidoSintetico = null;

      /* Pedido (Externo) */

      pedidoSelecionadoExterno: number = 0;

      pedidoSelecionadoExternoComVendaRealizada: boolean = false;

      /* Vendedor (Externo) */

      vendedorSelecionadoExterno: number = 0;

      /* Visita (Externa) */

      visitaSelecionadaExterna: number = 0;

  /* Formulário (Qualificação (Questões)) */

  formQualificacaoQuestoes: UntypedFormGroup;

  qualificacaoQuestoesEnviado: boolean = false;


  /* Histórico dos Últimos Pedidos / Orçamentos */

  ultimaCompra: Date = null;
  qtdeDiasSemComprar: number = 0;
  valorTicketMedio: number = 0;

  /* Histórico de Contatos: WhatsApp */

  atendimentosWhatsApp: WhatsAppOfficialAtendimento[] = [];
  carregadoAtendimentosWhatsApp: boolean = false;
  ultimaMensagemWhatsApp: Date = null;
  qtdeAtendimentosWhatsApp: number = 0;
  motivoPerdaMaisFrequenteWhatsApp: string = "";

  /* Histórico de Contatos: Ligações */

  ultimaVisita: Date = null;
  qtdeDiasSemVisita: number = 0;
  resultadoComMaiorFrequencia: string = "";

  /* Itens (Menu) */

  itemSelecionado: number = 0;

  /* Ligação - Finalizar */

  mensagemLigacao: string = "";
  observacaoVisitaAtual: string = "";

  agendarLigacaoData: { year: number, month: number, day: number } = null;
  agendarLigacaoDataInvalida: boolean = false;
  agendarLigacaoHora: { hour: number, minute: number } = null;

  ligacaoHoraAtual: { hour: number, minute: number } = null;

  /* MultiSelect */

  multiSelectConfiguracoes: IMultiSelectSettings = {
    buttonClasses: "btn btn-light btn-block"
  };

  multiSelectConfiguracoesTextos: IMultiSelectTexts = {
    defaultTitle: "Selecionar resposta(s)..."
  };

  /* Locais de Entrega */

  locaisEntrega: ClienteLocalEntrega[] = [];
  loadingLocalEntrega: boolean = false;
  erroLocalEntrega: string | null = null;
  atualizandoClienteTr: boolean = false;

  /* Notas Fiscais */

  notasFiscais: NotaFiscalSintetica[] = [];

  /* Pedidos (Cliente) */

  pedidosClientes: PedidoSintetico[] = [];
  pedidosEnviadosClientes: PedidoSintetico[] = [];
  pedidosNaoEnviadosClientes: PedidoSintetico[] = [];

  pedidoNaoEnviadoClienteHoje: PedidoSintetico = null;

  /* Pedidos (FatorFinanceiro) */

  exibirFatorFinanceiroEnviados: boolean = false;
  exibirFatorFinanceiroNaoEnviados: boolean = false;

  /* Pedidos Itens (Cliente) */

  pedidosItensClientes: PedidoItensSintetico[] = [];
  pedidosItensEnviadosClientes: PedidoItensSintetico[] = [];
  pedidosItensNaoEnviadosClientes: PedidoItensSintetico[] = [];

  /* Pedidos Itens Enviados (Cliente) */

  pedidosItensEnviados: PedidoItensSintetico[] = [];

  pedidosItensEnviadosExpandido: number = -1;

  /* Pedidos Itens Não Enviados (Cliente) */

  pedidosItensNaoEnviados: PedidoItensSintetico[] = [];

  pedidosItensNaoEnviadosExpandido: number = -1;

  /* Redirecionar */

  redirecionarPorTempo: boolean = false;

  /* Modal */

  @ViewChild("novaLigacao") novaLigacao: ElementRef;
  @ViewChild("iaChatLista") iaChatLista: ElementRef;

  /* Storage */

  is_master: boolean = (localStorage.getItem("is_master") == "true");
  is_manager: boolean = (localStorage.getItem("is_manager") == "true");
  is_diretor: boolean = (localStorage.getItem("is_diretor") == "true");
  is_financeiro: boolean = (localStorage.getItem("is_financeiro") == "true");
  modelo_tela_ligacoes: number = parseInt(localStorage.getItem("modelo_tela_ligacoes"));
  seller_id: number = parseInt(localStorage.getItem("id"));
  usa_pabx: boolean = (localStorage.getItem("usa_pabx") == "true");
  usa_whatsapp: boolean = (localStorage.getItem("usa_whatsapp") == "true");
  token_innersac: string = localStorage.getItem("token_innersac");
  link_innersac: string = localStorage.getItem("link_innersac");

  /* Resumo Financeiro */

  resumoFinanceiro: ResumoFinanceiro = null;
  resumoFinanceiroItens: TituloFinanceiro[] = [];
  resumoFinanceiroCarregando: boolean = false;
  resumoFinanceiroErro: boolean = false;
  resumoFinanceiroOrdemDesc: boolean = true;
  resumoFinanceiroOrdemVencimentoDesc: boolean = true;
  resumoFinanceiroOrdemAtiva: string = 'vencimento';

  /* WhatsApp Oficial */

  whatsappOficialAbrindo: boolean = false;
  whatsappOficialUrl: SafeResourceUrl = null;

  /* Kanban */
  kanbanNegociosCliente: KanbanNegocio[] = [];
  kanbanNegociosCarregando: boolean = false;
  kanbanNegocioSelecionadoExterno: number = 0;

  /* IA */
  iaPainelAberto: boolean = false;
  iaCarregando: boolean = false;
  iaPergunta: string = "";
  iaResposta: IaResposta = null;
  iaSugestao: IaResposta = null;
  iaHistoricoCarregando: boolean = false;
  iaHistoricoClienteId: number = null;
  iaMensagens: IaChatMensagem[] = [];
  iaProdutoAberto: number = null;
  iaProdutosPainelAberto: boolean = false;
  iaConfiguracao: IaConfiguracaoCliente = null;
  iaConfiguracaoCarregando: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private automacaoEventoService: AutomacaoEventoService,
    private callCenterService: CallCenterService,
    private callCenterDiscadorService: CallCenterDiscadorService,
    private canaisComunicacaoTelefoniaService: CanaisComunicacaoTelefoniaService,
    private centralAtendimentoService: CentralAtendimentoService,
    private clienteService: ClienteService,
    private configuracaoService: ConfiguracaoService,
    private conversaoService: ConversaoService,
    private excelService: ExcelService,
    private formatacaoService: FormatacaoService,
    private notaFiscalService: NotaFiscalService,
    private pedidoService: PedidoService,
    private pedidoItensService: PedidoItensService,
    private produtoService: ProdutoService,
    private tempoProgressivoService: TempoProgressivoService,
    private tempoRegressivoService: TempoRegressivoService,
    private vendedorService: VendedorService,
    private visitaService: VisitaService,
    private whatsAppOfficialService: WhatsAppOfficialService,
    private pdfService: PdfService,
    private kanbanService: KanbanService,
    private iaService: IaService
  ) { }

  alternarPainelIa() {
    if (this.cliente == null || this.cliente.client_id_app == null) {
      this.toastr.warning("", "Selecione um cliente para usar a IA.");
      return;
    }
    this.iaPainelAberto = !this.iaPainelAberto;
    this.iaProdutosPainelAberto = false;
    if (this.iaPainelAberto) this.carregarConfiguracaoIa();
  }

  fecharPainelIa() {
    this.iaPainelAberto = false;
    this.iaProdutosPainelAberto = false;
  }

  iaModuloHabilitado(): boolean {
    return this.iaConfiguracao != null && this.iaConfiguracao.is_configurada == true && this.iaConfiguracao.ia_ativa == true;
  }

  carregarConfiguracaoIa() {
    this.iaConfiguracaoCarregando = true;
    this.iaService.getConfiguration().subscribe(
      configuracao => {
        this.iaConfiguracao = configuracao || new IaConfiguracaoCliente();
        this.iaConfiguracaoCarregando = false;
        if (this.iaModuloHabilitado()) {
          this.carregarHistoricoIa();
        }
      },
      () => {
        this.iaConfiguracao = new IaConfiguracaoCliente();
        this.iaConfiguracaoCarregando = false;
      }
    );
  }

  perguntarIa() {
    if (this.cliente == null || !this.iaPergunta || this.iaPergunta.trim() == "") return;
    const pergunta = this.iaPergunta.trim();
    this.iaMensagens.push({ origem: "USUARIO", texto: pergunta, tipo: "CHAT", data: new Date() });
    this.iaPergunta = "";
    this.rolarChatIa();

    this.iaCarregando = true;
    this.iaService.chatCliente(this.cliente.client_id_app, pergunta, this.iaLigacaoId()).subscribe(
      resposta => {
        this.iaResposta = resposta;
        if (resposta != null) {
          this.iaMensagens.push({
            origem: "IA",
            texto: resposta.resposta,
            tipo: resposta.tipo || "CHAT",
            mensagem: resposta.mensagem,
            sucesso: resposta.sucesso,
            data: new Date()
          });
          this.rolarChatIa();
        }
        this.iaCarregando = false;
      },
      () => this.iaCarregando = false
    );
  }

  enviarPerguntaIaPorEnter(event: KeyboardEvent) {
    if (event.shiftKey) return;
    event.preventDefault();
    this.perguntarIa();
  }

  sugerirProdutosIa() {
    if (this.cliente == null || this.cliente.client_id_app == null) return;
    this.iaPainelAberto = true;
    this.iaProdutosPainelAberto = false;
    if (this.iaConfiguracao == null) {
      this.iaConfiguracaoCarregando = true;
      this.iaService.getConfiguration().subscribe(
        configuracao => {
          this.iaConfiguracao = configuracao || new IaConfiguracaoCliente();
          this.iaConfiguracaoCarregando = false;
          if (this.iaModuloHabilitado()) {
            this.abrirSugestaoProdutosIa();
          }
        },
        () => {
          this.iaConfiguracao = new IaConfiguracaoCliente();
          this.iaConfiguracaoCarregando = false;
        }
      );
      return;
    }
    if (!this.iaModuloHabilitado()) return;
    this.abrirSugestaoProdutosIa();
  }

  abrirSugestaoProdutosIa() {
    this.iaCarregando = true;
    this.iaProdutosPainelAberto = true;
    this.iaService.getUltimaSugestaoProdutos(this.cliente.client_id_app, this.iaLigacaoId()).subscribe(
      resposta => {
        if (resposta != null && resposta.sucesso && resposta.produtos_sugeridos != null && resposta.produtos_sugeridos.length > 0) {
          this.iaSugestao = resposta;
          this.iaProdutoAberto = null;
          this.iaCarregando = false;
        } else {
          this.atualizarSugestaoProdutosIa();
        }
      },
      () => this.atualizarSugestaoProdutosIa()
    );
  }

  atualizarSugestaoProdutosIa() {
    if (this.cliente == null || this.cliente.client_id_app == null) return;
    this.iaCarregando = true;
    this.iaProdutosPainelAberto = true;
    this.iaService.sugerirProdutosCliente(this.cliente.client_id_app, this.iaLigacaoId()).subscribe(
      resposta => {
        this.iaSugestao = resposta;
        this.iaProdutoAberto = null;
        this.iaCarregando = false;
      },
      () => this.iaCarregando = false
    );
  }

  copiarTextoIa(texto: string) {
    if (texto == null || texto == "") return;
    if (navigator != null && navigator.clipboard != null) {
      navigator.clipboard.writeText(texto).then(() => this.toastr.success("", "Texto copiado."));
    } else {
      this.toastr.info("", "Selecione e copie o texto da sugestao.");
    }
  }

  carregarHistoricoIa(force: boolean = false) {
    if (this.cliente == null || this.cliente.client_id_app == null) return;
    if (!force && this.iaHistoricoClienteId == this.cliente.client_id_app && this.iaMensagens.length > 0) {
      this.rolarChatIa();
      return;
    }

    this.iaHistoricoCarregando = true;
    this.iaService.getChatHistorico(this.cliente.client_id_app, this.iaLigacaoId()).subscribe(
      historico => {
        this.iaMensagens = this.montarMensagensHistorico(historico || []);
        this.iaHistoricoClienteId = this.cliente.client_id_app;
        this.iaHistoricoCarregando = false;
        this.rolarChatIa();
      },
      () => this.iaHistoricoCarregando = false
    );
  }

  fecharProdutosIa() {
    this.iaPainelAberto = false;
    this.iaProdutosPainelAberto = false;
  }

  produtosIaClienteCompra(): any[] {
    if (this.iaSugestao == null || this.iaSugestao.produtos_sugeridos == null) return [];
    return this.iaSugestao.produtos_sugeridos.filter(p => p.motivo == "historico_compra");
  }

  produtosIaSegmentoNaoCompra(): any[] {
    if (this.iaSugestao == null || this.iaSugestao.produtos_sugeridos == null) return [];
    return this.iaSugestao.produtos_sugeridos.filter(p => p.motivo != "historico_compra");
  }

  alternarProdutoIa(produto: any) {
    if (produto == null) return;
    this.iaProdutoAberto = this.iaProdutoAberto == produto.product_id ? null : produto.product_id;
  }

  condicoesProdutoIa(produto: any): any[] {
    if (produto == null || produto.condicoes_especiais == null) return [];
    return produto.condicoes_especiais;
  }

  private montarMensagensHistorico(historico: IaChatHistorico[]): IaChatMensagem[] {
    let mensagens: IaChatMensagem[] = [];

    historico
      .filter(item => item.tipo != "SUGESTAO_PRODUTOS")
      .forEach(item => {
      const data = item.data_criacao != null ? new Date(item.data_criacao) : null;
      if (item.pergunta != null && item.pergunta.trim() != "") {
        mensagens.push({ origem: "USUARIO", texto: item.pergunta, tipo: item.tipo, data: data });
      }

      if (item.resposta != null && item.resposta.trim() != "") {
        mensagens.push({
          origem: "IA",
          texto: item.resposta,
          tipo: item.tipo,
          mensagem: "Resposta da IA",
          sucesso: true,
          data: data
        });
      }
    });

    return mensagens;
  }

  private iaLigacaoId(): number {
    return this.ligacao != null ? this.ligacao.id : null;
  }

  private rolarChatIa() {
    setTimeout(() => {
      if (this.iaChatLista != null && this.iaChatLista.nativeElement != null) {
        this.iaChatLista.nativeElement.scrollTop = this.iaChatLista.nativeElement.scrollHeight;
      }
    }, 50);
  }

  ngOnDestroy() {
    this.modalService.dismissAll();

    if (this.router.routerState.snapshot.url.indexOf("pedidos-cadastro") !== 1) {
      /* Em Atendimento */

      this.atualizarEmAtendimento(false);

      /* Tempo Progressivo (Encerrar) */

      this.tempoProgressivoService.encerrarTempo();

      /* Storage */

      localStorage.setItem("id_call_center_ligacao", "0");
    }

    /* Tempo Regressivo (Encerrar) */

    this.tempoRegressivoService.encerrarTempo();

    /* Emitter */

    this.eventosEmitter.unsubscribe();
    this.redirecionarPorTempoEmitter.unsubscribe();
  }

  ngOnInit() {
    /* Emmiter */

    this.receberEventosTelefonia();
    this.receberRedirecionar();

    /* Externo */

      /* Cliente Consulta (Externo) */

      let idClienteConsulta: string = null;

      this.route.queryParams.subscribe(parametros => { idClienteConsulta = parametros["cliente_consulta"] });

      if (idClienteConsulta != null && !isNaN(parseInt(idClienteConsulta)) && isFinite(parseInt(idClienteConsulta))) {
        this.clienteConsultaSelecionadoExterno = parseInt(idClienteConsulta);
      }

      const atendimentoAnalise = Number(this.route.snapshot.queryParamMap.get('whatsapp_atendimento'));
      if (this.clienteConsultaSelecionadoExterno > 0 && Number.isSafeInteger(atendimentoAnalise) && atendimentoAnalise > 0) {
        this.whatsappAtendimentoAnaliseId = atendimentoAnalise;
      }

      /* Pedido (Externo) */

      let idPedido: string = null;

      this.route.queryParams.subscribe(parametros => { idPedido = parametros["pedido"] });

      if (idPedido != null && !isNaN(parseInt(idPedido)) && isFinite(parseInt(idPedido))) {
        this.pedidoSelecionadoExterno = parseInt(idPedido);
      }

      /* Vendedor (Externo) */

      let idVendedor: string = null;

      this.route.queryParams.subscribe(parametros => { idVendedor = parametros["vendedor"] });

      if (idVendedor != null && !isNaN(parseInt(idVendedor)) && isFinite(parseInt(idVendedor))) {
        this.vendedorSelecionadoExterno = parseInt(idVendedor);
      }

      /* Visita (Externa) */

      let idVisita: string = null;

      this.route.queryParams.subscribe(parametros => { idVisita = parametros["visita"] });

      if (idVisita != null && !isNaN(parseInt(idVisita)) && isFinite(parseInt(idVisita))) {
        this.visitaSelecionadaExterna = parseInt(idVisita);
      }

    /* Formulário (Qualificação (Questões)) */

    this.formQualificacaoQuestoes = new UntypedFormGroup({});

    this.carregarDados();
  }

  /* Call Center (Agendamentos) */

  deletarAgendamento(id: number) {
    let callCenterAgendamento = this.callCenterAgendamentos.findIndex(agendamento => agendamento.id == id);

    if (callCenterAgendamento != -1) {
      let deletarAgendamento: boolean = false;

      this.callCenterService.deleteAgendamentoById(id).subscribe(
        deletarAgendamentos => deletarAgendamento = deletarAgendamentos,
        error => { console.log("Erro: " + error) },
        () => {
          if (deletarAgendamento) {
            this.callCenterAgendamentos.splice(callCenterAgendamento, 1);

            this.callCenterAgendamentos = [...this.callCenterAgendamentos];

            this.toastr.success("", "Agendamento excluído com sucesso!");
          }
        }
      );
    }
  }

  /* Call Center (Resultados) */

  selecionarResultado(id_resultado: string) {
    this.resultadoSelecionado = this.resultados.find(resultado => resultado.id == parseInt(id_resultado));
  }

  /* Call Center (Status) */

  selecionarStatus(id_status: string) {
    this.statusSelecionado = this.status.find(status => status.id == parseInt(id_status));
  }

  /* Central de Atendimento */

  iniciarChamada(numero_telefone: string | number) {
    let numero: string = numero_telefone.toString().trim();

    if (numero == "") {
      this.toastr.error("", "Telefone em branco!");
    } else if (numero.length < 8) {
      this.toastr.error("", "Telefone inválido!");
    } else {
      this.centralAtendimentoService.adicionarEvento(new CentralAtendimentoEvento("telefonia", "iniciar_chamada", "", "", 0, false, false, false, false, false, "", "", numero, null, "", 0));
    }
  }

  iniciarChat(dddWhatsApp: string | number, telefoneWhatsApp: string | number) {
    if (dddWhatsApp.toString().trim() == "") {
      this.toastr.error("", "WhatsApp (DDD) em branco!");
    } else if (telefoneWhatsApp.toString().trim() == "") {
      this.toastr.error("", "WhatsApp (Telefone) em branco!");
    } else {
      if (this.token_innersac != "" && this.link_innersac != "") {
        this.router.navigate(["/whatsapp-innersac/" + dddWhatsApp.toString().trim() + telefoneWhatsApp.toString().trim()]);
      }

      /*
      let numero: string = this.conversaoService.telefoneParaTelefoneWhatsApp(dddWhatsApp.toString().trim() + telefoneWhatsApp.toString().trim());

      this.centralAtendimentoService.adicionarEvento(new CentralAtendimentoEvento("whatsapp", "iniciar_chat", "", "", 0, false, true, false, false, false, this.cliente.name, "", numero, null, "", this.cliente.client_id_app));
      */
    }
  }

  temWhatsAppOficialCliente(): boolean {
    return (this.dddWhatsApp != null && this.dddWhatsApp.toString().trim() != "") &&
      (this.telefoneWhatsApp != null && this.telefoneWhatsApp.toString().trim() != "");
  }

  abrirWhatsAppOficialAtendimento(content) {
    if (!this.temWhatsAppOficialCliente()) {
      this.toastr.error("", "Cliente sem número de WhatsApp cadastrado.");
      return;
    }

    this.whatsappOficialAbrindo = true;

    this.whatsAppOfficialService.openOrCreateConversation(
      this.cliente != null ? this.cliente.client_id_app : null,
      this.dddWhatsApp,
      this.telefoneWhatsApp,
      this.cliente != null ? this.cliente.name : ""
    ).subscribe(
      atendimento => {
        if (atendimento == null) {
          return;
        }

        let url = this.router.serializeUrl(this.router.createUrlTree(["/whatsapp-oficial"], {
          queryParams: {
            atendimento: atendimento.id,
            popup: 1
          }
        }));

        this.whatsappOficialUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-whatsapp-oficial-callcenter' });
      },
      error => { console.log("Erro: " + error) },
      () => this.whatsappOficialAbrindo = false
    );
  }

  /* Histórico de Contatos: abre um atendimento de WhatsApp especifico (ja existente) direto no mesmo modal usado em "Dados do Cliente" */
  abrirAtendimentoWhatsAppHistorico(content, atendimentoId: number) {
    let url = this.router.serializeUrl(this.router.createUrlTree(["/whatsapp-oficial"], {
      queryParams: {
        atendimento: atendimentoId,
        popup: 1
      }
    }));

    this.whatsappOficialUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-whatsapp-oficial-callcenter' });
  }

  /* Dados */

  atualizarEmAtendimento(em_atendimento: boolean) {
    let atualizarVendedor: boolean = false;

    this.vendedorService.updateEmAtendimentoByVendedor(em_atendimento).subscribe(
      atualizarVendedores => atualizarVendedor = atualizarVendedores,
      error => { console.log("Erro: " + error) },
      () => {

      }
    );
  }

  calcularDadosPedidos() {
    /* Histórico dos Últimos Pedidos / Orçamentos */

    if (this.pedidosEnviadosClientes.length > 0) {
      this.ultimaCompra = new Date(this.pedidosEnviadosClientes[0].order_sent_on);
      this.qtdeDiasSemComprar = parseInt(this.conversaoService.milissegundosParaDias(new Date().getTime() - this.ultimaCompra.getTime()).toFixed(0));

      let valorVendasTotal = this.pedidosEnviadosClientes.reduce((sum, current) => sum + current.total, 0);

      if (valorVendasTotal > 0) {
        this.valorTicketMedio = valorVendasTotal / this.pedidosEnviadosClientes.length;
      }
    }

    /* Análise de Vendas */

    this.calcularAnaliseVendas();
  }

  calcularAnaliseVendas() {
    /* Intervalo Médio entre Compras */

    this.intervaloMedioDiasCompra = 0;
    this.compraForaDoPadrao = false;

    if (this.pedidosEnviadosClientes.length >= 2) {
      let datasOrdenadas = this.pedidosEnviadosClientes
        .map(pedido => new Date(pedido.order_sent_on))
        .sort((a, b) => a.getTime() - b.getTime());

      let somaIntervalos = 0;
      let qtdeIntervalos = 0;

      for (var i = 1; i < datasOrdenadas.length; i++) {
        somaIntervalos += this.conversaoService.milissegundosParaDias(datasOrdenadas[i].getTime() - datasOrdenadas[i - 1].getTime());
        qtdeIntervalos++;
      }

      if (qtdeIntervalos > 0) {
        this.intervaloMedioDiasCompra = parseInt((somaIntervalos / qtdeIntervalos).toFixed(0));
      }
    }

    if (this.intervaloMedioDiasCompra > 0 && this.qtdeDiasSemComprar > 0) {
      this.compraForaDoPadrao = this.qtdeDiasSemComprar > (this.intervaloMedioDiasCompra * 1.3);
    }

    /* Produto que Sempre Compra e Não Apareceu no Último Pedido */

    this.produtoResgateNome = null;
    this.produtoResgateFrequencia = 0;
    this.produtoResgateTotalPedidosAnteriores = 0;
    this.produtoResgateTicketMedio = 0;

    let ultimosPedidos = this.pedidosEnviadosClientes.slice(0, 6); /* Já ordenado decrescente por data */

    if (ultimosPedidos.length >= 3) {
      let pedidoMaisRecente = ultimosPedidos[0];

      let produtosPedidoMaisRecente = new Set(
        this.pedidosItensEnviadosClientes.filter(item => item.order_id == pedidoMaisRecente.id).map(item => item.produto)
      );

      let pedidosAnteriores = ultimosPedidos.slice(1);

      let frequenciaProdutos: { [produto: string]: { qtdePedidos: number, valorTotal: number } } = {};

      pedidosAnteriores.forEach(pedido => {
        let produtosDoPedido = new Set(
          this.pedidosItensEnviadosClientes.filter(item => item.order_id == pedido.id).map(item => item.produto)
        );

        produtosDoPedido.forEach(produto => {
          if (!frequenciaProdutos[produto]) {
            frequenciaProdutos[produto] = { qtdePedidos: 0, valorTotal: 0 };
          }

          frequenciaProdutos[produto].qtdePedidos++;
          frequenciaProdutos[produto].valorTotal += this.pedidosItensEnviadosClientes
            .filter(item => item.order_id == pedido.id && item.produto == produto)
            .reduce((sum, current) => sum + current.total, 0);
        });
      });

      let limiteFrequencia = Math.ceil(pedidosAnteriores.length * 0.6);

      let candidatos = Object.keys(frequenciaProdutos)
        .filter(produto => !produtosPedidoMaisRecente.has(produto) && frequenciaProdutos[produto].qtdePedidos >= limiteFrequencia)
        .sort((a, b) => frequenciaProdutos[b].qtdePedidos - frequenciaProdutos[a].qtdePedidos);

      if (candidatos.length > 0) {
        let produtoEscolhido = candidatos[0];

        this.produtoResgateNome = produtoEscolhido;
        this.produtoResgateFrequencia = frequenciaProdutos[produtoEscolhido].qtdePedidos;
        this.produtoResgateTotalPedidosAnteriores = pedidosAnteriores.length;
        this.produtoResgateTicketMedio = this.formatacaoService.duasCasasDecimais(frequenciaProdutos[produtoEscolhido].valorTotal / frequenciaProdutos[produtoEscolhido].qtdePedidos);
      }
    }

    /* Vendas por Mês (Últimos 6 Meses) */

    this.vendasMensais6Meses = [];
    this.maiorValorVendaMensal = 0;

    let dataReferencia = new Date();
    let valoresMensais: { mes: string, valor: number, parcial: boolean }[] = [];

    for (var i = 0; i < 6; i++) {
      let anoRef = dataReferencia.getFullYear();
      let mesRef = dataReferencia.getMonth();

      let inicioMes = new Date(anoRef, mesRef, 1);
      let fimMes = i == 0 ? new Date() : new Date(anoRef, mesRef + 1, 0);

      let valorMes = this.pedidosItensEnviadosClientes.filter(item => {
        let data = new Date(item.order_sent_on);

        return data >= inicioMes && data <= fimMes;
      }).reduce((sum, current) => sum + current.total, 0);

      valoresMensais.push({
        mes: this.conversaoService.numeroParaMesPorExtenso(mesRef),
        valor: this.formatacaoService.duasCasasDecimais(valorMes),
        parcial: i == 0
      });

      dataReferencia = new Date(anoRef, mesRef - 1, 1);
    }

    valoresMensais.reverse();

    for (var i = 0; i < valoresMensais.length; i++) {
      let variacao = null;

      if (i > 0 && valoresMensais[i - 1].valor > 0) {
        variacao = this.formatacaoService.duasCasasDecimais(((valoresMensais[i].valor - valoresMensais[i - 1].valor) / valoresMensais[i - 1].valor) * 100);
      }

      this.vendasMensais6Meses.push(new CallCenterVendaMensal(valoresMensais[i].mes, valoresMensais[i].valor, variacao, valoresMensais[i].parcial));
    }

    this.maiorValorVendaMensal = Math.max(0, ...this.vendasMensais6Meses.map(v => v.valor));

    this.valorVendasMesAtual = 0;
    this.valorVendasMesAnterior = 0;
    this.variacaoMesPercentual = null;
    this.nomeMesAtual = "";
    this.nomeMesAnterior = "";

    if (this.vendasMensais6Meses.length >= 2) {
      let mesAtual = this.vendasMensais6Meses[this.vendasMensais6Meses.length - 1];
      let mesAnterior = this.vendasMensais6Meses[this.vendasMensais6Meses.length - 2];

      this.valorVendasMesAtual = mesAtual.valor;
      this.valorVendasMesAnterior = mesAnterior.valor;
      this.variacaoMesPercentual = mesAtual.variacao_percentual;
      this.nomeMesAtual = mesAtual.mes;
      this.nomeMesAnterior = mesAnterior.mes;
    }

    /* Vendas por Marca (Mês Atual) */

    this.vendasPorMarcaMesAtual = [];

    let inicioMesAtual = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

    let itensMesAtual = this.pedidosItensEnviadosClientes.filter(item => {
      let data = new Date(item.order_sent_on);

      return data >= inicioMesAtual && data <= new Date();
    });

    let totalMesAtualMarca = itensMesAtual.reduce((sum, current) => sum + current.total, 0);

    let itensPorMarca = itensMesAtual.reduce((obj, item) => {
      obj[item.grupo_estoque] = obj[item.grupo_estoque] || [];
      obj[item.grupo_estoque].push(item);

      return obj;
    }, {});

    this.vendasPorMarcaMesAtual = Object.keys(itensPorMarca).map(marca => {
      let valorMarca = itensPorMarca[marca].reduce((sum, current) => sum + current.total, 0);

      return new CallCenterVendaMarca(
        marca,
        this.formatacaoService.duasCasasDecimais(valorMarca),
        totalMesAtualMarca > 0 ? this.formatacaoService.duasCasasDecimais((valorMarca / totalMesAtualMarca) * 100) : 0
      );
    }).sort((a, b) => b.valor - a.valor);

    /* Top 10 Produtos (R$ e Litros, Mês Atual x Mês Anterior) */

    let inicioMesAnteriorTop = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    let fimMesAnteriorTop = new Date(new Date().getFullYear(), new Date().getMonth(), 0);

    let produtosDistintos = [...new Set(this.pedidosItensEnviadosClientes.map(item => item.produto))];

    this.topProdutosMes = produtosDistintos.map(produto => {
      let itensAtual = itensMesAtual.filter(item => item.produto == produto);

      let itensAnterior = this.pedidosItensEnviadosClientes.filter(item => {
        let data = new Date(item.order_sent_on);

        return data >= inicioMesAnteriorTop && data <= fimMesAnteriorTop && item.produto == produto;
      });

      let valorAtual = itensAtual.reduce((sum, current) => sum + current.total, 0);
      let valorAnterior = itensAnterior.reduce((sum, current) => sum + current.total, 0);
      let litrosAtual = itensAtual.reduce((sum, current) => sum + (current.total_litragem || 0), 0);
      let litrosAnterior = itensAnterior.reduce((sum, current) => sum + (current.total_litragem || 0), 0);

      let variacaoValor = valorAnterior > 0 ? this.formatacaoService.duasCasasDecimais(((valorAtual - valorAnterior) / valorAnterior) * 100) : null;
      let variacaoLitros = litrosAnterior > 0 ? this.formatacaoService.duasCasasDecimais(((litrosAtual - litrosAnterior) / litrosAnterior) * 100) : null;

      return new CallCenterTopProduto(
        produto,
        this.formatacaoService.duasCasasDecimais(valorAtual),
        this.formatacaoService.duasCasasDecimais(valorAnterior),
        variacaoValor,
        this.formatacaoService.duasCasasDecimais(litrosAtual),
        this.formatacaoService.duasCasasDecimais(litrosAnterior),
        variacaoLitros
      );
    }).filter(produto => produto.valor_atual > 0 || produto.valor_anterior > 0)
      .sort((a, b) => b.valor_atual - a.valor_atual)
      .slice(0, 10);

    /* Comparativo Trimestral por Produto (3 Meses x 3 Meses Anteriores) */

    let anoRefTrim = new Date().getFullYear();
    let mesRefTrim = new Date().getMonth();

    this.comparativoTrimestralDtInicioRecente = new Date(anoRefTrim, mesRefTrim - 3, 1);
    this.comparativoTrimestralDtFimRecente = new Date(anoRefTrim, mesRefTrim, 0);

    this.comparativoTrimestralDtInicioAnterior = new Date(anoRefTrim, mesRefTrim - 6, 1);
    this.comparativoTrimestralDtFimAnterior = new Date(anoRefTrim, mesRefTrim - 3, 0);

    this.comparativoTrimestralProdutos = produtosDistintos.map(produto => {
      let valorRecente = this.pedidosItensEnviadosClientes.filter(item => {
        let data = new Date(item.order_sent_on);

        return data >= this.comparativoTrimestralDtInicioRecente && data <= this.comparativoTrimestralDtFimRecente && item.produto == produto;
      }).reduce((sum, current) => sum + current.total, 0);

      let valorAnterior = this.pedidosItensEnviadosClientes.filter(item => {
        let data = new Date(item.order_sent_on);

        return data >= this.comparativoTrimestralDtInicioAnterior && data <= this.comparativoTrimestralDtFimAnterior && item.produto == produto;
      }).reduce((sum, current) => sum + current.total, 0);

      let variacao = valorAnterior > 0 ? this.formatacaoService.duasCasasDecimais(((valorRecente - valorAnterior) / valorAnterior) * 100) : null;

      return new CallCenterComparativoTrimestralProduto(
        produto,
        this.formatacaoService.duasCasasDecimais(valorRecente),
        this.formatacaoService.duasCasasDecimais(valorAnterior),
        variacao
      );
    }).filter(produto => produto.valor_recente > 0 || produto.valor_anterior > 0)
      .sort((a, b) => Math.abs(b.variacao_percentual || 0) - Math.abs(a.variacao_percentual || 0));
  }

  formatarVariacaoPercentual(valor: number): string {
    if (valor == null) {
      return "—";
    }

    let seta = valor >= 0 ? "↑" : "↓";

    return seta + " " + Math.abs(valor).toFixed(0) + "%";
  }

  classeVariacaoPercentual(valor: number): string {
    if (valor == null) {
      return "";
    }

    return valor >= 0 ? "av_delta_up" : "av_delta_down";
  }

  calcularLarguraDivergente(valor: number): number {
    if (valor == null) {
      return 0;
    }

    return Math.min(Math.abs(valor), 50) / 50 * 60;
  }

  calcularDadosVisitas() {
    if (this.clienteConsultaSelecionadoExterno != 0) {
      this.ultimaVisita = new Date(this.visitas[0].check_in);
    } else {
      let data = this.datePipe.transform(this.visitas[0].check_in, "yyyy/MM/dd");

      if (data == this.datePipe.transform(new Date(), "yyyy/MM/dd")) {
        this.visitas.splice(0, 1);

        this.visitas = [...this.visitas];

        if (this.visitas.length > 0) {
          this.ultimaVisita = new Date(this.visitas[0].check_in);
        }
      } else {
        this.ultimaVisita = new Date(this.visitas[0].check_in);
      }
    }

    if (this.ultimaVisita != null) {
      this.qtdeDiasSemVisita = parseInt(this.conversaoService.milissegundosParaDias(new Date().getTime() - this.ultimaVisita.getTime()).toFixed(0));
    }

    let visitasAgrupadas = this.visitas.filter(visita => visita.name != null).reduce((obj, item) => {
      obj[item.name] = obj[item.name] || [];
      obj[item.name].push(item);

      return obj;
    }, {});

    visitasAgrupadas = Object.keys(visitasAgrupadas).map((objeto) => {
      return {
        key: objeto,
        value: visitasAgrupadas[objeto]
      };
    }).sort((a, b) => {
      const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

      return compare(a.value.length, b.value.length) * -1; /* Decrescente */
    });

    this.resultadoComMaiorFrequencia = Object.keys(visitasAgrupadas).length > 0 ? visitasAgrupadas[0].key : "";
  }

  carregarDados() {
    this.carregando = true;

    /* Configurações */

    this.configuracaoService.getByGuidClienteNapis().subscribe(
      configuracoes => this.configuracao = configuracoes,
      error => { console.log("Erro: " + error) },
      () => {
        /* Call Center (Configurações) */

        this.callCenterService.getConfiguracaoByGuidClienteNapis().subscribe(
          callCenterConfiguracao => this.callCenterConfiguracao = callCenterConfiguracao,
          error => { console.log("Erro: " + error) },
          () => {
            /* Call Center (Resultados) */

            this.callCenterService.getResultadoByGuidClienteNapis().subscribe(
              resultados => this.resultados = resultados,
              error => { console.log("Erro: " + error) },
              () => {
                if (this.resultados.length > 0) {
                  this.resultadoSelecionado = this.resultados[0];
                }

                /* Call Center (Status) */

                this.callCenterService.getStatus().subscribe(
                  status => this.status = status,
                  error => { console.log("Erro: " + error) },
                  () => {
                    if (this.status.length > 0) {
                      this.statusSelecionado = this.status.find(status => status.id == 5); /* Não Comprou */
                    }

                    this.carregarLigacao();
                  }
                );
              }
            );
          }
        );
      }
    );
  }

  carregarDadosCesta() {
    if (!this.carregadoCesta) {
      /* Produtos (Cesta) */

      this.produtoService.getProdutoCestaByGuidClienteNapis(this.cliente.segment).subscribe(
        produtoCesta => this.produtosCesta = produtoCesta,
        error => { console.log("Erro: " + error) },
        () => {

        }
      );
    }
  }

  carregarDadosCliente(client_id_app: number) {
    let retorno = new Promise<void>((resolver) => {
      /* Cliente */

      this.clienteService.getById(client_id_app).subscribe(
        clientes => this.cliente = clientes,
        error => { console.log("Erro: " + error) },
        () => {
          if (this.cliente != null) {
            this.cliente.name = this.cliente.name.trim().toUpperCase();
            this.cliente.endereco_completo = "";

            if (this.cliente.tipo_logradouro != null) {
              this.cliente.endereco_completo = this.cliente.endereco_completo + this.cliente.tipo_logradouro.trim();
            }

            if (this.cliente.endereco != null) {
              this.cliente.endereco_completo = this.cliente.endereco_completo + " " + this.cliente.endereco.trim();
            }

            if (this.cliente.end_numero != null) {
              this.cliente.endereco_completo = this.cliente.endereco_completo + ", " + this.cliente.end_numero.trim();
            }

            if (this.cliente.cidade != null) {
              this.cliente.endereco_completo = this.cliente.endereco_completo + " / " + this.cliente.cidade.trim();
            }

            this.cliente.endereco_completo = this.cliente.endereco_completo.trim().toUpperCase();

            this.insideSales = this.cliente.inside_sales_ativo == null ? false : this.cliente.inside_sales_ativo;
            this.contatoCliente = this.cliente.contato_callcenter == null ? "" : this.cliente.contato_callcenter;
            this.telefone_2 = this.cliente.fone_02 == null ? "" : this.cliente.fone_02;
            this.telefone_3 = this.cliente.fone_03 == null ? "" : this.cliente.fone_03;
            this.dddWhatsApp = this.cliente.fone_whatss_ddd == null ? "" : this.cliente.fone_whatss_ddd;
            this.telefoneWhatsApp = this.cliente.fone_whatss == null ? "" : this.cliente.fone_whatss;
            this.email_02 = this.cliente.email_02 == null ? "" : this.cliente.email_02;
            this.observacaoCliente = this.cliente.note == null ? "" : this.cliente.note;

            /* Call Center (Agendamentos) */

            this.callCenterService.getAgendamentoByCliente(this.cliente.client_id_app).subscribe(
              callCenterAgendamento => this.callCenterAgendamentos = callCenterAgendamento,
              error => { console.log("Erro: " + error) },
              () => {
                this.carregando = false;
                this.carregarKanbanNegociosCliente();

                return resolver();
              }
            )
          }
        }
      );
    });

    return retorno;
  }

  carregarDadosPedidos() {
    if (!this.carregadoPedidos) {
      /* Cliente (Tabela) */

      this.clienteService.getTabelaByIdCliente(this.cliente.client_id_app).subscribe(
        tabelaCliente => this.tabelasClientes = tabelaCliente,
        error => { console.log("Erro: " + error) },
        () => {
          /* Pedidos */

          this.pedidoService.getByCliente(this.cliente.client_id_app).subscribe(
            pedidoCliente => this.pedidosClientes = pedidoCliente,
            error => { console.log("Erro: " + error) },
            () => {
              let pedidosEnviadosClientes = this.pedidosClientes.filter(pedidoCliente => pedidoCliente.order_sent_on != null && pedidoCliente.dt_integracao != null);

              this.pedidosEnviadosClientes = JSON.parse(JSON.stringify(pedidosEnviadosClientes));

              this.pedidosEnviadosClientes = this.pedidosEnviadosClientes.sort((a, b) => {
                const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

                let dataAnterior = this.datePipe.transform(a["order_sent_on"], "yyyy/MM/dd");
                let proximaData = this.datePipe.transform(b["order_sent_on"], "yyyy/MM/dd");

                return compare(dataAnterior, proximaData) * -1; /* Decrescente */
              });

              let pedidosNaoEnviadosClientes = this.pedidosClientes.filter(pedidoCliente => pedidoCliente.order_sent_on == null && pedidoCliente.dt_integracao == null && (pedidoCliente.status_pedido == "Orçamento" || pedidoCliente.status_pedido == "Não Enviado" || pedidoCliente.status_pedido == "Reprovado"));

              this.pedidosNaoEnviadosClientes = JSON.parse(JSON.stringify(pedidosNaoEnviadosClientes));

              this.pedidosNaoEnviadosClientes.forEach((item) => {
                let data = this.datePipe.transform(item.order_created_at, "yyyy/MM/dd");

                if (data == this.datePipe.transform(new Date(), "yyyy/MM/dd")) {
                  this.pedidoNaoEnviadoClienteHoje = item;
                }
              });

              this.pedidosNaoEnviadosClientes = this.pedidosNaoEnviadosClientes.sort((a, b) => {
                const compare = (v1, v2) => v1 == null ? -1 : v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

                let dataAnterior = this.datePipe.transform(a["order_created_at"], "yyyy/MM/dd");
                let proximaData = this.datePipe.transform(b["order_created_at"], "yyyy/MM/dd");

                return compare(dataAnterior, proximaData) * -1; /* Decrescente */
              });

              /* Pedidos Itens */

              this.pedidoItensService.getByCliente(this.cliente.client_id_app).subscribe(
                pedidoItensCliente => this.pedidosItensClientes = pedidoItensCliente,
                error => { console.log("Erro: " + error) },
                () => {
                  if (this.pedidosItensClientes.length > 0) {
                    let pedidosItensEnviadosClientes = this.pedidosItensClientes.filter(pedidoItemCliente => pedidoItemCliente.order_sent_on != null && pedidoItemCliente.dt_integracao != null);

                    this.pedidosItensEnviadosClientes = JSON.parse(JSON.stringify(pedidosItensEnviadosClientes));

                    let pedidosItensNaoEnviadosClientes = this.pedidosItensClientes.filter(pedidoItemCliente => pedidoItemCliente.order_sent_on == null);

                    this.pedidosItensNaoEnviadosClientes = JSON.parse(JSON.stringify(pedidosItensNaoEnviadosClientes));

                    /* Grupos Estoque */

                    this.produtoService.getGrupoEstoqueByGuidClienteNapis().subscribe(
                      grupoEstoque => this.gruposEstoque = grupoEstoque,
                      error => { console.log("Erro: " + error) },
                      () => {
                        for (var i = 0; i < this.gruposEstoque.length; i++) {
                          let qtdeGrupoEstoque = this.pedidosItensEnviadosClientes.filter(pedidoItensClientes => pedidoItensClientes.grupo_estoque == this.gruposEstoque[i]).length;

                          if (qtdeGrupoEstoque > 0) {
                            this.gruposEstoque.splice(i, 1);

                            this.gruposEstoque = [...this.gruposEstoque];
                          }
                        }

                        this.calcularDadosPedidos();

                        this.carregadoPedidos = true;
                      }
                    );
                  }
                }
              );
            }
          );
        }
      );
    }
  }

  carregarDadosQualificacao() {
    if (!this.carregadoQualificacao) {
      /* Qualificação (Questões) */

      this.callCenterService.getQualificacaoQuestaoByGuidClienteNapis().subscribe(
        callCenterQualificacaoQuestao => this.callCenterQualificacaoQuestoes = callCenterQualificacaoQuestao,
        error => { console.log("Erro: " + error) },
        () => {
          /* Formulário (Qualificação (Questões)) */

          this.callCenterQualificacaoQuestoes.forEach((item) => {
            if (item.tipo == "multipla_escolha") {
              this.formQualificacaoQuestoes.addControl(item.id.toString(), this.formBuilder.control([]));
            } else {
              this.formQualificacaoQuestoes.addControl(item.id.toString(), this.formBuilder.control(""));
            }

            if (item.flag_obrigatoria) {
              this.formQualificacaoQuestoes.controls[item.id].setValidators(Validators.required);
            }
          });

          /* Qualificação (Questões (Respostas)) */

          this.callCenterService.getCallCenterQualificacaoQuestaoResposta(this.ligacao.client_id).subscribe(
            callCenterQualificacaoQuestoesResposta => this.callCenterQualificacaoQuestoesRespostas = callCenterQualificacaoQuestoesResposta,
            error => { console.log("Erro: " + error) },
            () => {
              this.callCenterQualificacaoQuestoes.forEach((item) => {
                if (item.tipo == "escrita") {
                  /* Escrita */

                  let respostaLocalizada = this.callCenterQualificacaoQuestoesRespostas.find(resposta => resposta.id_call_center_qualificacao_questao == item.id);

                  if (respostaLocalizada != null) {
                    this.formQualificacaoQuestoes.controls[item.id].setValue(respostaLocalizada.resposta);
                  }
                } else if (item.tipo == "multipla_escolha") {
                  /* Múltipla Escolha */

                  let respostas: any = [];

                  this.callCenterQualificacaoQuestoesRespostas.filter(x => x.id_call_center_qualificacao_questao == item.id).forEach((item) => {
                    respostas.push(item.id_call_center_qualificacao_questao_alternativa);
                  });

                  this.formQualificacaoQuestoes.controls[item.id].setValue(respostas);
                } else if (item.tipo == "unica_alternativa") {
                  /* Única Alternativa */

                  let respostaLocalizada = this.callCenterQualificacaoQuestoesRespostas.find(resposta => resposta.id_call_center_qualificacao_questao == item.id);

                  if (respostaLocalizada != null) {
                    this.formQualificacaoQuestoes.controls[item.id].setValue(respostaLocalizada.id_call_center_qualificacao_questao_alternativa);
                  }
                }

                /* MultiSelect */

                if (item.tipo == "multipla_escolha") {
                  item.opcoes = [];

                  item.alternativas.forEach((subItem) => {
                    item.opcoes.push({
                      id: subItem.id,
                      name: subItem.descricao
                    })
                  });
                }
              });

              this.carregadoQualificacao = true;
            }
          );
        }
      );
    }
  }

  async enviarPdfPedidoAnalise(pedido: PedidoSintetico) {
    if (!this.whatsappAtendimentoAnaliseId || this.clienteConsultaSelecionadoExterno <= 0 || this.pedidoPdfEnviando ||
        !pedido || !(pedido.order_id_app > 0) || !(pedido.seller_id > 0) ||
        ![...this.pedidosEnviadosClientes, ...this.pedidosNaoEnviadosClientes].includes(pedido)) {
      return;
    }

    const atendimentoId = this.whatsappAtendimentoAnaliseId;
    const numeroPedido = pedido.order_id_app;
    const vendedorId = pedido.seller_id;
    this.pedidoPdfEnviando = pedido;
    try {
      const arquivo = await this.pdfService.gerarArquivoPedidoOrcamento(numeroPedido, vendedorId);
      const mensagem = await firstValueFrom(this.whatsAppOfficialService.sendDocumentMessage(atendimentoId, arquivo));
      if (mensagem != null) {
        this.toastr.success('', 'PDF do pedido ' + numeroPedido + ' enviado para a conversa de origem.');
      }
    } catch (error) {
      this.toastr.error('', error instanceof Error ? error.message : 'Não foi possível gerar ou enviar o PDF do pedido.');
    } finally {
      this.pedidoPdfEnviando = null;
    }
  }

  carregarAtendimentosWhatsApp() {
    if (this.carregadoAtendimentosWhatsApp) {
      return;
    }

    this.whatsAppOfficialService.getAtendimentosByClient(this.cliente.id).subscribe(
      atendimentos => this.atendimentosWhatsApp = atendimentos || [],
      error => { console.log("Erro: " + error) },
      () => {
        this.calcularDadosAtendimentosWhatsApp();
        this.carregadoAtendimentosWhatsApp = true;
      }
    );
  }

  calcularDadosAtendimentosWhatsApp() {
    if (this.atendimentosWhatsApp.length == 0) {
      return;
    }

    this.qtdeAtendimentosWhatsApp = this.atendimentosWhatsApp.length;
    this.ultimaMensagemWhatsApp = this.atendimentosWhatsApp[0].dt_primeira_mensagem != null ? new Date(this.atendimentosWhatsApp[0].dt_primeira_mensagem) : null;

    let motivosAgrupados = this.atendimentosWhatsApp
      .filter(atendimento => atendimento.motivo_perda_nome != null)
      .reduce((obj, item) => {
        obj[item.motivo_perda_nome] = obj[item.motivo_perda_nome] || [];
        obj[item.motivo_perda_nome].push(item);

        return obj;
      }, {});

    let motivosOrdenados = Object.keys(motivosAgrupados).map((chave) => {
      return { key: chave, value: motivosAgrupados[chave] };
    }).sort((a, b) => b.value.length - a.value.length);

    this.motivoPerdaMaisFrequenteWhatsApp = motivosOrdenados.length > 0 ? motivosOrdenados[0].key : "";
  }

  carregarDadosVisitas() {
    if (!this.carregadoVisitas) {
      /* Visitas */

      this.visitaService.getVisitaByCliente(this.cliente.client_id_app).subscribe(
        visitas => this.visitas = visitas,
        error => { console.log("Erro: " + error) },
        () => {
          if (this.visitas.length > 0) {
            this.visitas.forEach((item) => {
              if (item.no_order_done_reason_id == null || item.no_order_done_reason_id == 0) {
                item.name = "Venda Realizada";
              }
            });

            this.calcularDadosVisitas();
          }

          this.carregadoVisitas = true;
        }
      );
    }
  }

  /* Emitter */

  receberEventosTelefonia() {
    this.eventosEmitter = this.canaisComunicacaoTelefoniaService.eventosEmitter.subscribe(
      canaisComunicacaoTelefoniaEventos => {
        if (this.callCenterConfiguracao != null) {
          if (this.callCenterConfiguracao.fechamento_automatico_ligacao) {
            if (canaisComunicacaoTelefoniaEventos != null) {
              switch (canaisComunicacaoTelefoniaEventos.acao) {
                case "chamada_encerrada":
                  let tempoAtendimento: number = this.callCenterConfiguracao.tempo_atendimento == null ? 0 : this.callCenterConfiguracao.tempo_atendimento;

                  this.tempoRegressivoService.iniciarTempo(tempoAtendimento);

                  break;
                case "chamada_em_andamento":
                case "discando":
                case "recebendo":
                  this.tempoRegressivoService.encerrarTempo();

                  break;
                default:

              }
            }
          }
        }
      }
    );
  }

  receberRedirecionar() {
    this.redirecionarPorTempoEmitter = this.tempoRegressivoService.redirecionarPorTempoEmitter.subscribe(
      redirecionarPorTempo => {
        if (redirecionarPorTempo) {
          this.redirecionarPorTempo = true;

          this.finalizarLigacaoAtual();
        }
      }
    );
  }
   
  /* Eventos */

  verificarAutomacaoEventos() {
    let automacaoEvento: AutomacaoEvento = null;

    this.automacaoEventoService.getByEvento("FINALIZAR LIGACAO").subscribe(
      automacaoEventos => automacaoEvento = automacaoEventos,
      error => { console.log("Erro: " + error) },
      () => {
        if (automacaoEvento != null) {
          let automacaoEnvio = new AutomacaoEnvio();

          automacaoEnvio.email = this.cliente.email;
          automacaoEnvio.phone = this.cliente.phone;
          automacaoEnvio.idvisit = this.visita.id;
          automacaoEnvio.dataligacao = this.datePipe.transform(new Date(), "yyyy-MM-dd");
          automacaoEnvio.razaosocial = this.cliente.name;
          automacaoEnvio.cidade = this.cliente.cidade;
          automacaoEnvio.sellerid = this.visita.seller_id;
          automacaoEnvio.vendedorexterno = this.visita.fullname != null ? this.visita.fullname : "";
          automacaoEnvio.emailvendedor = this.visita.email_real != null ? this.visita.email_real : "";
          automacaoEnvio.statusligacao = this.statusSelecionado.name;
          automacaoEnvio.resultadoligacao = this.resultadoSelecionado.name;
          automacaoEnvio.anotacoes = this.observacaoVisitaAtual;
          automacaoEnvio.segmento = this.cliente.segment;
          automacaoEnvio.fone_whatss = this.cliente.fone_whatss != null ? this.cliente.fone_whatss : "";
          automacaoEnvio.fone_whatss_ddd = this.cliente.fone_whatss_ddd != null ? this.cliente.fone_whatss_ddd : "";
          automacaoEnvio.responsible_name = this.cliente.responsible_name != null ? this.cliente.responsible_name : "";
          automacaoEnvio.contato_callcenter = this.cliente.contato_callcenter != null ? this.cliente.contato_callcenter : "";
          automacaoEnvio.client_id_app = this.cliente.client_id_app;

          let iniciarEvento: boolean = false;

          this.automacaoEventoService.iniciarEvento(automacaoEvento.link_evento, automacaoEnvio).subscribe(
            iniciarEventos => iniciarEvento = iniciarEventos,
            error => { console.log("Erro: " + error) },
            () => {
              if (iniciarEvento) {
                this.toastr.success("", "E-mail enviado com sucesso!");
              }
            }
          );
        }
      }
    );
  }

  /* Exportar */

  exportarHistoricoLigacoes() {
    /* Histórico de Ligações */

    this.excelService.exportAsExcelFile(this.visitas, "Histórico de Ligações");
  }

  exportarHistoricoUltimosPedidos() {
    /* Histórico dos Últimos Pedidos / Orçamentos */

    this.excelService.exportAsExcelFile(this.pedidosEnviadosClientes, "Histórico dos Últimos Pedidos / Orçamentos (Enviados)");
    this.excelService.exportAsExcelFile(this.pedidosNaoEnviadosClientes, "Histórico dos Últimos Pedidos / Orçamentos (Não Enviados)");
  }

  /* Formatação */

  formatarValoresQuatroCasasDecimais(valor: number) {
    if (valor != null) {
      return (valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 4
      });
    }
  }

  /* Ligação (Iniciar/Finalizar) */

    /* Cliente */

    updateCliente() {
      let alterarCliente: boolean = false;

      this.clienteService.updateContatoById(this.cliente.client_id_app, this.contatoCliente, this.email_02, this.observacaoCliente, this.telefone_2, this.telefone_3, this.dddWhatsApp, this.telefoneWhatsApp, this.insideSales).subscribe(
        alterarClientes => alterarCliente = alterarClientes,
        error => { console.log("Erro: " + error) },
        () => {
          if (alterarCliente) {
            this.toastr.success("", "Cliente atualizado com sucesso!");
          }
        }
      );
    }

    deveAtualizarUltimaVisitaCliente() {
      if (this.statusSelecionado != null && this.statusSelecionado.id == 4) {
        return true;
      }

      let resultado = this.resultadoSelecionado;

      if (this.redirecionarPorTempo) {
        let resultadoCheckOutAberto: CallCenterResultado = this.resultados.find(resultado => resultado.flag_check_out_aberto);

        if (resultadoCheckOutAberto != null) {
          resultado = resultadoCheckOutAberto;
        }
      }

      if (resultado == null || resultado.flag_visita_efetiva == null) {
        return true;
      }

      return resultado.flag_visita_efetiva !== false;
    }

    updateUltimaVisitaCliente() {
      if (this.cliente == null || !this.deveAtualizarUltimaVisitaCliente()) {
        return;
      }

      this.clienteService.updateUltimaVisitaById(this.cliente.client_id_app).subscribe(
        () => { },
        error => { console.log("Erro: " + error) }
      );
    }

    updateClienteWhatsApp() {
      let alterarWhatsApp: boolean = false;

      this.clienteService.updateWhatsAppById(this.cliente.client_id_app, this.dddWhatsApp, this.telefoneWhatsApp).subscribe(
        alterarWhatsApps => alterarWhatsApp = alterarWhatsApps,
        error => { console.log("Erro: " + error) },
        () => {

        }
      );
    }

    removerCaracteres(evento: KeyboardEvent) {
      if (evento.keyCode > 31 && (evento.keyCode < 48 || evento.keyCode > 57)) {
        evento.stopImmediatePropagation();

        return false;
      }

      return true;
    }

    removerCaracteresTelefone(evento: ClipboardEvent, telefone: number) {
      let elemento = evento.target as HTMLInputElement;
      let texto = evento.clipboardData.getData("text/plain");

      if (texto != null) {
        texto = texto.replace(/\D/g, "");

        elemento.value = texto;

        switch (telefone) {
          case 2:
            this.telefone_2 = texto;

            break;
          case 3:
            this.telefone_3 = texto;

            break;
          default:
        }

        evento.preventDefault();
      }
    }

    /* Ligação */

    carregarLigacao() {
      this.router.routeReuseStrategy.shouldReuseRoute = () => {
        return false;
      }

      let id: string = null;

      this.route.params.subscribe(params => { id = params.id; });

      if (id != null && !isNaN(parseInt(id)) && isFinite(parseInt(id))) {
        const prepararReceberDadosLigacao = this.prepararReceberDadosLigacao(parseInt(id));

        prepararReceberDadosLigacao.then(() => {
          if (this.visitaSelecionadaExterna == 0) {
            this.addUpdateVisita(false);
          } else {
            const prepararReceberDadosVisita = this.prepararReceberDadosVisita(this.visitaSelecionadaExterna);

            prepararReceberDadosVisita.then(() => {
              if (this.pedidoSelecionadoExterno != 0) {
                this.addUpdateVisita(false);
                this.updateLigacaoAtual(false);
              }
            });
          }

          /* Em Atendimento */

          if (this.clienteConsultaSelecionadoExterno == 0) {
            this.atualizarEmAtendimento(true);
          }

          /* Tempo Progressivo (Iniciar) */

          if (this.pedidoSelecionadoExterno == 0) {
            this.tempoProgressivoService.iniciarTempo();
          }

          /* Tempo Regressivo (Iniciar) */

          if (this.callCenterConfiguracao != null) {
            if (this.callCenterConfiguracao.fechamento_automatico_ligacao) {
              let tempoAtendimento: number = this.callCenterConfiguracao.tempo_atendimento == null ? 0 : this.callCenterConfiguracao.tempo_atendimento;

              this.tempoRegressivoService.iniciarTempo(tempoAtendimento);
            }
          }
        });
      } else {
        if (this.clienteConsultaSelecionadoExterno != 0) {
          this.ligacao = new CallCenterLigacaoAnalitica();

          this.ligacao.manual = true;

          this.carregarDadosCliente(this.clienteConsultaSelecionadoExterno);
        } else {
          this.router.navigate(["/call-center"]);
        }
      }
    }

    prepararEnviarDadosLigacao(ligacao_futura: boolean) {
      /* Ligação */

      let ligacao = new CallCenterLigacaoAnalitica();

      ligacao.client_id = this.cliente.client_id_app;
      ligacao.seller_id = this.cliente.seller_id;
      ligacao.tmp = 1;
      ligacao.id_tmk = this.seller_id;
      ligacao.manual = this.ligacao.manual;
      ligacao.lista = this.ligacao.lista;

      if (ligacao_futura) {
        /* Futura */

        ligacao.tipo = "F"; /* Feita */
        ligacao.id_status = 6; /* Agendada */

        if (this.agendarLigacaoHora != null && this.agendarLigacaoHora.hour != null && this.agendarLigacaoHora.minute != null) {
          let dataLigacaoInicial = new Date(this.agendarLigacaoData.year, this.agendarLigacaoData.month - 1, this.agendarLigacaoData.day, this.agendarLigacaoHora.hour, this.agendarLigacaoHora.minute, 0);

          ligacao.data_ligacao = new Date(this.datePipe.transform(dataLigacaoInicial, "yyyy/MM/dd HH:mm:ss", "GMT-6"));
        } else {
          let dataLigacaoInicial = new Date(this.agendarLigacaoData.year, this.agendarLigacaoData.month - 1, this.agendarLigacaoData.day, 0, 0, 0);

          ligacao.data_ligacao = new Date(this.datePipe.transform(dataLigacaoInicial, "yyyy/MM/dd HH:mm:ss", "GMT-6"));
        }

        ligacao.manual = null;

        this.ligacaoFutura = ligacao;
      } else {
        /* Atual */

        ligacao.id = this.ligacao.id;
        ligacao.tipo = this.ligacao.tipo;

        if (this.redirecionarPorTempo) {
          ligacao.id_status = this.status.find(status => status.id == 5).id; /* Não Comprou */
        } else {
          ligacao.id_status = this.statusSelecionado.id_status;
        }

        if (this.ligacaoHoraAtual != null && this.ligacaoHoraAtual.hour != null && this.ligacaoHoraAtual.minute != null) {
          let dataLigacao = new Date();

          dataLigacao.setHours(this.ligacaoHoraAtual.hour);
          dataLigacao.setMinutes(this.ligacaoHoraAtual.minute);
          dataLigacao.setSeconds(0);

          ligacao.data_ligacao = new Date(this.datePipe.transform(dataLigacao, "yyyy/MM/dd HH:mm:ss", "GMT-6"));
        } else {
          ligacao.data_ligacao = new Date(this.datePipe.transform(Date.now(), "yyyy/MM/dd HH:mm:ss", "GMT-6"));
        }

        ligacao.mensagem = this.mensagemLigacao;

        this.ligacao = ligacao;
      }
    }

    prepararReceberDadosLigacao(id_ligacao: number) {
      let retorno = new Promise<void>((resolver) => {
        /* Ligação */

        this.callCenterService.getById(id_ligacao).subscribe(
          ligacao => this.ligacao = ligacao,
          error => { console.log("Erro: " + error) },
          () => {
            if (this.ligacao != null) {
              this.mensagemLigacao = this.ligacao.mensagem;

              if (this.pedidoSelecionadoExterno == 0) {
                /* Status */

                if (this.ligacao.id_status == 1 || this.ligacao.id_status == 6) { /* 1 = À Ligar / 6 = Agendada */
                  this.statusSelecionado = this.status.find(status => status.id == 5); /* Não Comprou */
                } else {
                  this.statusSelecionado = this.status.find(status => status.id == this.ligacao.id_status);
                }
              } else {
                /* Pedido */

                let pedido: Pedido = null;

                this.pedidoService.getByOrder(this.pedidoSelecionadoExterno, this.vendedorSelecionadoExterno).subscribe(
                  pedidos => pedido = pedidos,
                  error => { console.log("Erro: " + error) },
                  () => {
                    if (pedido != null && pedido.order_sent_on != null) {
                      this.statusSelecionado = this.status.find(status => status.id == 4); /* Venda Realizada */

                      this.pedidoSelecionadoExternoComVendaRealizada = true;

                      this.itemSelecionado = 6; /* Concluir Ligação */
                    } else {
                      this.statusSelecionado = this.status.find(status => status.id == this.ligacao.id_status);
                    }
                  }
                );
              }

              /* Storage */

              localStorage.setItem("id_call_center_ligacao", this.ligacao.id.toString());

              const carregarDadosCliente = this.carregarDadosCliente(this.ligacao.client_id);

              carregarDadosCliente.then(() => {
                return resolver();
              });
            } else if (this.visitaSelecionadaExterna > 0) {
              /* Veio do fluxo de "check-out pendente" (visit.id_call_center_ligacao
                 aponta pra uma ligação que não existe mais / nunca existiu - dado
                 órfão). Sem isso o vendedor fica travado: a tela sempre mostra
                 "Ligação não encontrada" e a visita nunca fecha o check-out.
                 Encerra a visita direto (Visita/Update só grava check_out,
                 no_order_done_reason_id, note e callcenter_status - não depende
                 da ligação). */

              this.visitaService.getById(this.visitaSelecionadaExterna).subscribe(
                visitaPendente => this.visita = visitaPendente,
                error => { console.log("Erro: " + error) },
                () => {
                  if (this.visita != null) {
                    this.visitaService.update(this.visita).subscribe(
                      () => { },
                      error => { console.log("Erro: " + error) },
                      () => {
                        this.toastr.warning("", "A ligação vinculada a este check-in não foi encontrada. A visita foi encerrada automaticamente.");

                        this.router.navigate(["/call-center"]);
                      }
                    );
                  } else {
                    this.toastr.warning("", "Ligação não encontrada.");

                    this.router.navigate(["/call-center"]);
                  }
                }
              );
            } else {
              /* Ligação não encontrada (ex.: id inválido) - evita tela em branco */

              this.toastr.warning("", "Ligação não encontrada.");

              this.router.navigate(["/call-center"]);
            }
          }
        );
      });

      return retorno;
    }

    /* Ligação Atual */

    updateLigacaoAtual(finalizando: boolean) {
      if (this.ligacao != null) {
        this.prepararEnviarDadosLigacao(false);

        let alterarLigacao: boolean = false;

        this.callCenterService.updateLigacao(this.ligacao).subscribe(
          alterarLigacoes => alterarLigacao = alterarLigacoes,
          error => { console.log("Erro: " + error) },
          () => {
            if (alterarLigacao) {
              if (finalizando) {
                this.toastr.success("", "Ligação salva com sucesso!");
              }
            }
          }
        );
      }
    }

    finalizarLigacaoAtual() {
      this.agendarLigacaoDataInvalida = false;

      if (this.agendarLigacaoData != null) {
        let data = new Date(this.agendarLigacaoData.year, this.agendarLigacaoData.month - 1, this.agendarLigacaoData.day);

        if (data < new Date()) {
          this.agendarLigacaoDataInvalida = true;
        } else {
          this.addLigacaoFutura();
        }
      }

      if (!this.agendarLigacaoDataInvalida) {
        this.addUpdateVisita(true);
        this.updateLigacaoAtual(true);
        this.finalizarKanbanComoGanhoQuandoVendaRealizada();
        this.updateCliente();
        this.updateUltimaVisitaCliente();

        this.router.navigate(["/call-center"]);

        this.callCenterDiscadorService.chamadasReiniciadas();
      }
    }

    finalizarKanbanComoGanhoQuandoVendaRealizada() {
      if (this.kanbanNegocioSelecionadoExterno <= 0 || this.statusSelecionado == null || this.statusSelecionado.id != 4) {
        return;
      }

      this.kanbanService.finishDeal(this.kanbanNegocioSelecionadoExterno, "GANHO").subscribe(
        finalizado => {
          if (!finalizado) {
            this.toastr.warning("", "A ligacao foi finalizada, mas nao foi possivel marcar o negocio como ganho.");
          }
        },
        error => { console.log("Erro: " + error) }
      );
    }

    /* Ligação Futura */

    addLigacaoFutura() {
      this.prepararEnviarDadosLigacao(true);

      let adicionarLigacao: boolean = false;

      this.callCenterService.addLigacao(this.ligacaoFutura).subscribe(
        adicionarLigacoes => adicionarLigacao = adicionarLigacoes,
        error => { console.log("Erro: " + error) },
        () => {
          if (adicionarLigacao) {
            this.toastr.success("", "Ligação agendada com sucesso!");
          }
        }
      );
    }

    /* Qualificação Cliente */

    addQualificacaoQuestoes() {
      this.qualificacaoQuestoesEnviado = true;

      if (!this.formQualificacaoQuestoes.invalid) {
        if (this.ligacao != null) {
          let respostas: CallCenterQualificacaoQuestaoResposta[] = [];

          this.callCenterQualificacaoQuestoes.forEach((item) => {
            if (this.formQualificacaoQuestoes.controls[item.id].value != null && this.formQualificacaoQuestoes.controls[item.id].value != "") {
              let resposta = new CallCenterQualificacaoQuestaoResposta();

              resposta.id_call_center_qualificacao_questao = item.id;
              resposta.id_call_center_ligacao = this.ligacao.id;

              if (item.tipo == "escrita") {
                /* Escrita */

                resposta.id_call_center_qualificacao_questao_alternativa = null;
                resposta.resposta = this.formQualificacaoQuestoes.controls[item.id].value;

                respostas.push(resposta);
              } else if (item.tipo == "multipla_escolha") {
                /* Múltipla Escolha */

                let valores: any[] = this.formQualificacaoQuestoes.controls[item.id].value;

                valores.forEach((subItem) => {
                  if (subItem != "") {
                    let respostaMultiplaEscolha = new CallCenterQualificacaoQuestaoResposta();

                    respostaMultiplaEscolha.id_call_center_qualificacao_questao = item.id;
                    respostaMultiplaEscolha.id_call_center_qualificacao_questao_alternativa = subItem;
                    respostaMultiplaEscolha.id_call_center_ligacao = this.ligacao.id;
                    respostaMultiplaEscolha.resposta = null;

                    respostas.push(respostaMultiplaEscolha);
                  }
                });
              } else if (item.tipo == "unica_alternativa") {
                /* Única Alternativa */

                resposta.id_call_center_qualificacao_questao_alternativa = parseInt(this.formQualificacaoQuestoes.controls[item.id].value);
                resposta.resposta = null;

                respostas.push(resposta);
              }
            }
          });

          console.log(respostas);

          let adicionarCallCenterQualificacaoQuestaoResposta: boolean = false;

          this.callCenterService.addCallCenterQualificacaoQuestaoResposta(respostas).subscribe(
            adicionarCallCenterQualificacaoQuestaoRespostas => adicionarCallCenterQualificacaoQuestaoResposta = adicionarCallCenterQualificacaoQuestaoRespostas,
            error => { console.log("Erro: " + error) },
            () => {
              if (adicionarCallCenterQualificacaoQuestaoResposta) {
                this.toastr.success("", "Qualificação salva com sucesso!");
              }
            }
          );
        }
      }
    }

    /* Visita */

    addUpdateVisita(finalizando: boolean) {
      /* Visita */

      if (this.visita != null) {
        /* Alterando */

        const prepararEnviarDadosVisita = this.prepararEnviarDadosVisita();

        prepararEnviarDadosVisita.then(() => {
          let alterarVisita: boolean = false;

          this.visitaService.update(this.visita).subscribe(
            alterarVisitas => alterarVisita = alterarVisitas,
            error => { console.log("Erro: " + error) },
            () => {
              if (alterarVisita) {
                if (finalizando) {
                  this.verificarAutomacaoEventos();

                  this.toastr.success("", "Visita salva com sucesso!");
                }
              }
            }
          )
        });
      } else {
        /* Adicionando */

        this.visitaService.getProximoNumeroVisitaBySeller().subscribe(
          nroVisita => this.nroVisita = nroVisita,
          error => { console.log("Erro: " + error) },
          () => {
            if (this.nroVisita > 0) {
              const prepararEnviarDadosVisita = this.prepararEnviarDadosVisita();

              prepararEnviarDadosVisita.then(() => {
                let adicionarVisita: boolean = false;

                this.visitaService.add(this.visita).subscribe(
                  adicionarVisitas => adicionarVisita = adicionarVisitas,
                  error => { console.log("Erro: " + error) },
                  () => {
                    if (adicionarVisita) {
                      this.visitaService.getUltimaVisitaByCliente(this.visita.client_id).subscribe(
                        visitas => this.visita = visitas,
                        error => { console.log("Erro: " + error) },
                        () => {

                        }
                      );
                    }
                  }
                );
              });
            }
          }
        );
      }
    }

    prepararEnviarDadosVisita() {
      let retorno = new Promise<void>((resolver) => {
        /* Visita */

        let visita = new Visita();

        if (this.visita != null) {
          visita.id = this.visita.id;
          visita.fullname = this.visita.fullname;
          visita.email_real = this.visita.email_real;
        }

        visita.client_id = this.cliente.client_id_app;
        visita.check_in_distance_in_meters = 0;

        if (this.visita == null) {
          visita.no_order_done_reason_id = null;
        }

        if (this.pedidoSelecionadoExterno == 0) {
          if (this.statusSelecionado.id == 4) { /* Venda Realizada */
            visita.no_order_done_reason_id = null;
          } else {
            if (this.redirecionarPorTempo) {
              let resultado: CallCenterResultado = this.resultados.find(resultado => resultado.flag_check_out_aberto);

              if (resultado != null) {
                visita.no_order_done_reason_id = resultado.id;
              } else {
                visita.no_order_done_reason_id = null;
              }
            } else {
              visita.no_order_done_reason_id = this.resultadoSelecionado.id;
            }
          }

          if (this.redirecionarPorTempo) {
            visita.note = "Visita finalizada automaticamente";
          } else {
            visita.note = this.observacaoVisitaAtual;
          }

          visita.is_active = true;
          visita.seller_id = this.seller_id;
          visita.visit_id_app = this.nroVisita;
          visita.callcenter_tipo = this.ligacao.tipo;
          visita.callcenter_status = this.statusSelecionado.id;
          visita.id_call_center_ligacao = this.ligacao.id;

          this.visita = visita;

          return resolver();
        } else {
          let pedido: Pedido = null;

          this.pedidoService.getByOrder(this.pedidoSelecionadoExterno, this.vendedorSelecionadoExterno).subscribe(
            pedidos => pedido = pedidos,
            error => { console.log("Erro: " + error) },
            () => {
              if (pedido != null && pedido.order_sent_on != null) {
                /* Pedido */

                visita.no_order_done_reason_id = null;
              } else {
                /* Orçamento */

                visita.no_order_done_reason_id = this.resultadoSelecionado.id;
              }

              if (this.redirecionarPorTempo) {
                visita.note = "Visita finalizada automaticamente";
              } else {
                visita.note = this.observacaoVisitaAtual;
              }

              visita.is_active = true;
              visita.seller_id = this.seller_id;
              visita.visit_id_app = this.nroVisita;
              visita.callcenter_tipo = this.ligacao.tipo;
              visita.callcenter_status = this.statusSelecionado.id;
              visita.id_call_center_ligacao = this.ligacao.id;

              this.visita = visita;

              return resolver();
            }
          );
        }
      });

      return retorno;
    }

    prepararReceberDadosVisita(id_visita) {
      let retorno = new Promise<void>((resolver) => {
        this.visitaService.getById(id_visita).subscribe(
          visita => this.visita = visita,
          error => { console.log("Erro: " + error) },
          () => {
            if (this.visita != null) {
              return resolver();
            }
          }
        )
      });

      return retorno;
    }

  /* Inside Sales */

  selecionarInsadeSales(ativo: string) {
    this.insideSales = ativo == "0" ? false : true;
  }

  /* Itens (Enviados) */

  expandirPedidosItensEnviados(i: number, id: number) {
    this.exibirFatorFinanceiroEnviados = false;

    this.pedidosItensEnviadosExpandido = i == this.pedidosItensEnviadosExpandido ? -1 : i;

    if (this.pedidosItensEnviadosExpandido > -1) {
      this.pedidosItensEnviados = this.pedidosItensEnviadosClientes.filter(pedidoItensCliente => {
        return pedidoItensCliente.order_id == id;
      });

      let qtdeProdutosFatorFinanceiro: number = this.pedidosItensEnviados.filter(pedidoItensCliente => pedidoItensCliente.fator_financeiro != null && pedidoItensCliente.fator_financeiro != 0).length;

      if (qtdeProdutosFatorFinanceiro > 0) {
        this.exibirFatorFinanceiroEnviados = true;
      }
    }
  }

  /* Itens (Menu) */

  alterarItemSelecionado(item: number) {
    this.itemSelecionado = item;

    if (this.itemSelecionado == 1) {
      // Qualificação do Cliente

      this.carregarDadosQualificacao();
    } else if (this.itemSelecionado == 2) {
      // Cesta

      this.carregarDadosCesta();
    } else if (this.itemSelecionado == 3 || this.itemSelecionado == 4) {
      // Análise de Vendas / (Histórico de Pedidos / Orçamentos)

      this.carregarDadosPedidos();
    } else if (this.itemSelecionado == 5) {
      // Histórico de Contatos (WhatsApp + Ligações)

      this.carregarAtendimentosWhatsApp();
      this.carregarDadosVisitas();
    }
  }

  alterarPedidoOrcamento() {
    this.updateCliente();

    this.router.navigate(["/pedidos-cadastro/" + this.pedidoNaoEnviadoClienteHoje.order_id_app], {
      queryParams: {
        cliente: this.cliente.codigo_no_erp_do_cliente,
        ligacao: this.ligacao.id,
        vendedor: this.pedidoNaoEnviadoClienteHoje.seller_id,
        visita: this.visita.id
      }
    });
  }

  novoPedidoOrcamento() {
    if (this.configuracao.permite_lancar_pedido_inadimplente == "N") {
      /* Inadimplente */

      if (this.cliente.status_financeiro != null) {
        this.toastr.warning("", "Cliente c/ inadimplência!");

        return;
      }
    }

    this.updateCliente();

    this.router.navigate(["/pedidos-cadastro"], {
      queryParams: {
        cliente: this.cliente.codigo_no_erp_do_cliente,
        ligacao: this.ligacao.id,
        visita: this.visita.id
      }
    });
  }

  retornarDashboardOportunidades() {
    this.router.navigate(["/dashboard-oportunidades"]);
  }

  /* Itens (Não Enviados) */

  expandirPedidosItensNaoEnviados(i: number, id: number) {
    this.exibirFatorFinanceiroNaoEnviados = false;

    this.pedidosItensNaoEnviadosExpandido = i == this.pedidosItensNaoEnviadosExpandido ? -1 : i;

    if (this.pedidosItensNaoEnviadosExpandido > -1) {
      this.pedidosItensNaoEnviados = this.pedidosItensNaoEnviadosClientes.filter(pedidoItensCliente => {
        return pedidoItensCliente.order_id == id;
      });

      let qtdeProdutosFatorFinanceiro: number = this.pedidosItensNaoEnviados.filter(pedidoItensCliente => pedidoItensCliente.fator_financeiro != null && pedidoItensCliente.fator_financeiro != 0).length;

      if (qtdeProdutosFatorFinanceiro > 0) {
        this.exibirFatorFinanceiroNaoEnviados = true;
      }
    }
  }

  /* Modal */

  modalAlterarAgendamento(content: any, id: number) {
    this.callCenterAgendamentoSelecionado = this.callCenterAgendamentos.find(agendamento => agendamento.id == id);

    if (this.callCenterAgendamentoSelecionado != null) {
      if (!this.alterarLigacaoDataInvalida) {
        let dataLigacao = new Date(this.callCenterAgendamentoSelecionado.data_ligacao);

        this.alterarLigacaoData = {
          year: dataLigacao.getFullYear(),
          month: dataLigacao.getMonth() + 1,
          day: dataLigacao.getDate()
        };

        this.alterarLigacaoDataInvalida = false;

        this.alterarLigacaoHora = {
          hour: dataLigacao.getHours(),
          minute: dataLigacao.getMinutes()
        };
      }

      this.modalService.open(content, {
        ariaLabelledBy: "titulo-alterar-agendamento",
        size: "lg",
        backdrop: "static"
      }).result.then((acao) => {
        if (acao == "Salvar") {
          let dataLigacao: Date = new Date();
          let dataLigacaoInicial: Date = new Date();

          if (this.alterarLigacaoHora != null) {
            dataLigacaoInicial = new Date(this.alterarLigacaoData.year, this.alterarLigacaoData.month - 1, this.alterarLigacaoData.day, this.alterarLigacaoHora.hour, this.alterarLigacaoHora.minute, 0);

            dataLigacao = new Date(this.datePipe.transform(dataLigacaoInicial, "yyyy/MM/dd HH:mm:ss", "GMT-6"));
          } else {
            dataLigacaoInicial = new Date(this.alterarLigacaoData.year, this.alterarLigacaoData.month - 1, this.alterarLigacaoData.day, 0, 0, 0);

            dataLigacao = new Date(this.datePipe.transform(dataLigacaoInicial, "yyyy/MM/dd HH:mm:ss", "GMT-6"));
          }

          if (dataLigacao < new Date()) {
            this.alterarLigacaoDataInvalida = true;

            this.modalAlterarAgendamento(content, id);
          } else {
            this.alterarLigacaoDataInvalida = false;

            let alterarAgendamento: boolean = false;

            this.callCenterService.updateAgendamentoDataById(id, dataLigacao).subscribe(
              alterarAgendamentos => alterarAgendamento = alterarAgendamentos,
              error => { console.log("Erro: " + error) },
              () => {
                if (alterarAgendamento) {
                  this.callCenterAgendamentoSelecionado.data_ligacao = dataLigacaoInicial;

                  this.toastr.success("", "Agendamento atualizado com sucesso!");
                }
              }
            );
          }
        }
      }, () => {

      });
    }
  }

  modalAlterarVisita(content: any, id: number) {
    this.observacaoVisita = "";

    this.visitaSelecionada = this.visitas.find(visita => visita.id == id);

    if (this.visitaSelecionada != null) {
      this.observacaoVisita = this.visitaSelecionada.note;

      this.modalService.open(content, {
        ariaLabelledBy: "titulo-alterar-visita",
        size: "lg",
        backdrop: "static"
      }).result.then((acao) => {
        if (acao == "Salvar") {
          let alterarVisita: boolean = false;

          this.visitaService.updateObservacaoById(this.visitaSelecionada.id, this.observacaoVisita).subscribe(
            alterarVisitas => alterarVisita = alterarVisitas,
            error => { console.log("Erro: " + error) },
            () => {
              if (alterarVisita) {
                this.visitaSelecionada.note = this.observacaoVisita;

                this.toastr.success("", "Visita alterada com sucesso!");

                this.visitaSelecionada = null;
              }
            }
          );
        }
      }, () => {

      });
    }
  }

  modalNotasFiscaisSinteticas(content: any, client_document: string) {
    client_document = client_document.replace(/[.]/g, "").replace(/[/]/g, "").replace(/[-]/g, "");

    this.notaFiscalService.getNotaFiscalSinteticaByCNPJ(client_document).subscribe(
      notaFiscal => this.notasFiscais = notaFiscal,
      error => { console.log("Erro: " + error) },
      () => {
        if (this.notasFiscais.length > 0) {
          this.modalService.open(content, {
            ariaLabelledBy: "titulo-notas-fiscais-sinteticas",
            size: "lg",
            backdrop: "static"
          });
        } else {
          this.toastr.error("", "Nenhuma nota fiscal encontrada!");
        }
      }
    );
  }

  modalLocaisEntrega(content: any) {
    this.locaisEntrega = [];
    this.loadingLocalEntrega = true;
    this.erroLocalEntrega = null;

    this.modalService.open(content, {
      ariaLabelledBy: "titulo-locais-entrega",
      size: "xl",
      backdrop: "static"
    });

    this.clienteService.getClienteLocalEntregaByCliente(this.cliente.id).subscribe(
      locais => this.locaisEntrega = locais,
      error => {
        console.log("Erro: " + error);
        this.loadingLocalEntrega = false;
        this.erroLocalEntrega = "Erro ao carregar locais de entrega. Tente novamente.";
      },
      () => {
        this.loadingLocalEntrega = false;
      }
    );
  }

  /* Números */

  get podeAtualizarClienteTr(): boolean {
    return this.is_master || this.is_diretor || this.is_financeiro;
  }

  exibirAtualizarClienteTr(): boolean {
    const tipoIntegracaoErp = (this.configuracao?.integracao_erp_tipo || "").toUpperCase();

    return this.podeAtualizarClienteTr
      && this.configuracao != null
      && (tipoIntegracaoErp == "SAPSERVICELAYER" || tipoIntegracaoErp == "SANKHYAGATEWAY")
      && this.cliente != null
      && this.cliente.client_id_app != null
      && this.cliente.codigo_no_erp_do_cliente != null
      && this.cliente.codigo_no_erp_do_cliente != "";
  }

  atualizarClienteTr() {
    if (!this.exibirAtualizarClienteTr() || this.atualizandoClienteTr) {
      return;
    }

    this.atualizandoClienteTr = true;

    this.clienteService.atualizarClienteSapServiceLayer(this.cliente.client_id_app).subscribe(
      resultado => {
        if (resultado != null && resultado.sucesso) {
          this.toastr.success("", resultado.mensagem || "Cliente TR atualizado com sucesso.");
          this.carregarDadosCliente(this.cliente.client_id_app);
          this.recarregarLocaisEntregaCliente();
        }
      },
      error => {
        console.log("Erro: " + error);
        this.atualizandoClienteTr = false;
      },
      () => {
        this.atualizandoClienteTr = false;
      }
    );
  }

  recarregarLocaisEntregaCliente() {
    if (this.cliente == null || this.cliente.id == null) {
      return;
    }

    this.clienteService.getClienteLocalEntregaByCliente(this.cliente.id).subscribe(
      locais => this.locaisEntrega = locais,
      error => { console.log("Erro: " + error) }
    );
  }

  somenteNumeros(element: HTMLInputElement) {
    element.value = element.value.replace(/[^0-9]/gi, "");
  }

  /* Análise Financeira */

  abrirAnaliseFinanceiraCliente(content) {
    if (this.cliente == null || !this.cliente.codigo_no_erp_do_cliente) { return; }
    this.modalService.open(content, { size: 'xl', centered: true });
    this.resumoFinanceiroCarregando = true;
    this.resumoFinanceiroErro = false;
    this.resumoFinanceiro = null;
    this.resumoFinanceiroItens = [];
    this.pedidoService.getResumoFinanceiroPorCliente(
      this.configuracao.guidclientenapis,
      this.cliente.codigo_no_erp_do_cliente,
      this.cliente.name
    ).subscribe(
      resumo => this.resumoFinanceiro = resumo,
      () => { this.resumoFinanceiroErro = true; this.resumoFinanceiroCarregando = false; },
      () => {
        if (this.resumoFinanceiro != null) {
          this.resumoFinanceiroItens = (this.resumoFinanceiro.itens || []).map((item: any) => ({
            docDate: item.docDate || item.DocDate,
            dueDate: item.dueDate || item.DueDate,
            serial: item.serial || item.Serial,
            parcela: item.parcela || item.Parcela,
            instTotal: item.instTotal != null ? item.instTotal : item.InsTotal,
            dataPagamento: item.dataPagamento || item.DataPagamento,
            saldoAberto: item.saldoAberto ?? item.SaldoAberto,
            paidToDate: item.paidToDate != null ? item.paidToDate : item.PaidToDate,
            status: item.status || item.Status,
            dias: item.dias != null ? item.dias : item.Dias,
          }));
          this.ordenarResumoFinanceiroCC();
        }
        this.resumoFinanceiroCarregando = false;
      }
    );
  }

  ordenarResumoFinanceiroCC() {
    if (this.resumoFinanceiroOrdemAtiva === 'vencimento') {
      this.resumoFinanceiroItens = this.resumoFinanceiroItens.sort((a, b) => {
        const dateA = new Date(a.dueDate).getTime();
        const dateB = new Date(b.dueDate).getTime();
        return this.resumoFinanceiroOrdemVencimentoDesc ? dateB - dateA : dateA - dateB;
      });
    } else {
      this.resumoFinanceiroItens = this.resumoFinanceiroItens.sort((a, b) =>
        this.resumoFinanceiroOrdemDesc ? b.instTotal - a.instTotal : a.instTotal - b.instTotal
      );
    }
  }

  alternarOrdemResumoFinanceiroCC() {
    this.resumoFinanceiroOrdemAtiva = 'valor';
    this.resumoFinanceiroOrdemDesc = !this.resumoFinanceiroOrdemDesc;
    this.ordenarResumoFinanceiroCC();
  }

  alternarOrdemResumoFinanceiroVencimentoCC() {
    this.resumoFinanceiroOrdemAtiva = 'vencimento';
    this.resumoFinanceiroOrdemVencimentoDesc = !this.resumoFinanceiroOrdemVencimentoDesc;
    this.ordenarResumoFinanceiroCC();
  }

  /* Kanban */

  carregarKanbanNegociosCliente() {
    this.kanbanNegociosCliente = [];
    if (this.cliente == null || this.cliente.id == null) {
      return;
    }
    this.kanbanNegociosCarregando = true;
    this.kanbanService.getOpenDealsByClient(this.cliente.id).subscribe(
      negocios => this.kanbanNegociosCliente = negocios || [],
      error => { console.log("Erro: " + error); this.kanbanNegociosCarregando = false; },
      () => this.kanbanNegociosCarregando = false
    );
  }

  abrirKanbanNegocios(content: any) {
    if (this.kanbanNegociosCliente.length == 0) {
      return;
    }
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  abrirKanbanFiltradoCliente(modal: any) {
    if (modal != null) {
      modal.dismiss('Abrir Kanban');
    }
    this.router.navigate(['/kanban'], { queryParams: { cliente_id: this.cliente?.id } });
  }
}
